import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdalConfigService } from './adal-config.service';
import { AdalAccessGuard } from './adal-access.guard';
import { AdalService } from './adal.service';
import { HttpClientModule } from '@angular/common/http';
import {InterceptedHttp} from "../intercepted-http";
/* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS } from '@angular/common/http';
//import { AuthInterceptor } from './auth-interceptor';


/** Http interceptor providers in outside-in order */
// export const httpInterceptorProviders = [
//   { 
//     provide: HTTP_INTERCEPTORS, useClass: InterceptedHttp, multi: true 
//   },
// ];

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule
  ],
  declarations: [],
  providers: [AdalConfigService, AdalService, AdalAccessGuard]
})
export class SharedModule { }



// WEBPACK FOOTER //
// ./src/app/services/shared.module.ts